import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "../ModalContentWrapper";
import {getCustomDataFromResponse, getDataFromResponse, getErrorFromResponse} from "root/DataFunctions/BaseDataFns";
import {createSchool, getSchool, updateSchoolDetails} from "root/DataFunctions/SchoolDataFns";

import '../TwoColumnModal.scss';
import SpinnerDiv from "ui/SpinnerDiv";

import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import DropdownSchoolAttendanceOfficers from "root/ReactHookForm/ui/DropdownSchoolAttendanceOfficers";
import {SaveButton} from "root/Modals/SaveButton";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

import "react-toggle/style.css";
import './ModalSchool.scss' ;

import {useSessionContext} from "root/Contexts/SessionContext";
import {UserTypes} from "root/DataFunctions/Constants";

import FormFragmentSchoolDetails from "./FormFragmentSchoolDetails";
import BootstrapRow from "ui/BootstrapRow";

export const ModalSchoolModes = {
    CREATE: 'create',
    EDIT: 'edit',
    VIEW: 'view',
    DELETE: 'delete',
}

const ModalSchool = ({mode, school_id, onSaveCompleted, onClose}) =>
{
    const { user_type } = useSessionContext();

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                school: {
                    school_id: null,
                    school_group_id: null,
                    school_name: null,
                    address1: null,
                    address2: null,
                    address3: null,
                    address4: null,
                    postcode: null,
                    phone: null,
                    email: null,
                    user_id: null,
                    school_type_id: null,
                    pep_process_opt_out: false
                }
            }
        });

    const [data, setData] = useState({ isLoading: true, data: [] });

    const [ buttonsDisabled, setButtonsDisabled ] = useState ( false ) ;
    const [ formError, setFormError ] = useState ( null ) ;

    useEffect(() =>
    {
        if ( mode === 'edit')
        {
            getSchool(school_id, (response) =>
            {
                let schoolData = getDataFromResponse(response)[0] ;

                const custom = getCustomDataFromResponse(response) ;

                schoolData.school_group_id = null;

                if ( custom?.groups !== undefined )
                {
                    if ( custom.groups.length != 0 )
                    {
                        const school_group_id = custom.groups[0].school_group_id ;

                        schoolData.school_group_id = school_group_id;
                    }
                }

                const desi_id = schoolData.user_id === null ? -1 : +schoolData.user_id ;

                const value = {
                    school_id: schoolData.school_id ,
                    school_group_id: schoolData.school_group_id === null ? null : { value: +(schoolData.school_group_id) },
                    school_name: schoolData.school_name,
                    address1: schoolData.address1,
                    address2: schoolData.address2,
                    address3: schoolData.address3,
                    address4: schoolData.address4,
                    postcode: schoolData.postcode,
                    phone: schoolData.phone,
                    email: schoolData.email,
                    user_id: { value: desi_id },
                    school_type_id: schoolData.school_type_id == null ? null : { value: +schoolData.school_type_id },
                    pep_process_opt_out: +(schoolData.pep_process_opt_out) === 1
                }

                setValue('school', value);

                setData({ isLoading: false, data: schoolData });
            });
        }
        else
        {
            if ( mode === ModalSchoolModes.CREATE)
            {
                setData({ isLoading: false, data: [] });
            }
        }

    }, [school_id]);

    const doUpdate = ( data ) =>
    {
        updateSchoolDetails ( school_id, data, () =>
        {
            onSaveCompleted ('saved');
            onClose() ;
        }) ;
    }

    const doSaveNew = ( data ) =>
    {
        createSchool( data, (response) =>
        {
            if ( getErrorFromResponse(response) === 'EXISTS')
            {
                setButtonsDisabled( false );
                setFormError("A school with this school ID already exists")
            }
            else
            {
                onSaveCompleted ('saved');
                onClose() ;
            }
        }) ;
    }

    const onClickCancel = () =>
    {
        onSaveCompleted ('cancel');
        onClose() ;
    }

    const onSubmit = (data) =>
    {
        setButtonsDisabled( true );

        switch ( mode )
        {
            case ModalSchoolModes.EDIT:
                doUpdate( data ) ;
                break;
            case ModalSchoolModes.CREATE:
                doSaveNew( data ) ;
                break;
            default:
                throw new Error ( 'Invalid mode on save')
        }
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const validateAttendanceOfficer = (val) =>
    {
        if (val === null)
        {
            return "Please Select an attendance Officer.";
        }
    }


    const canDisablePEP = [ UserTypes.LEAD_CAREERS_ADVISOR, UserTypes.TEAM_LEAD ].includes(user_type) ;

    const renderForm = () =>
    {
        const shouldShowAttendanceOfficer = mode !== ModalSchoolModes.CREATE ;
        const readOnlyMode = false ;

        return (
            <Fragment>

                <div className='buy-card-right modal-school-form' style={{marginBottom: '20px', marginTop: '20px'}}>
                    <form className='' onSubmit={handleSubmit(onSubmit)}>

                        <FormFragmentSchoolDetails mode={mode} formError={formError} control={control} register={register} formErrors={formErrors} sectionName='school' readOnly={readOnlyMode}/>

                        {shouldShowAttendanceOfficer === true && <BootstrapRow>
                            <div className='col-md-12'>
                                <label>Attendance Responsibility</label>
                                <DropdownSchoolAttendanceOfficers name='school.user_id' school_id={school_id} control={control} rules={{validate: validateAttendanceOfficer}}
                                                                  placeHolder='Please Select an Attendance Officer' readOnly={false}/>
                                {formErrors.school?.user_id && <ErrorDiv>{formErrors.school.user_id.message}</ErrorDiv>}
                            </div>
                        </BootstrapRow>}

                        {canDisablePEP === true && <BootstrapRow>
                            <div className='col-md-12'>
                                <label>Opted out of PEP Process</label>
                                <div key='asas' className='pep-opt-out-row'>
                                    <div key='k1' style={{fontStyle: 'italic', color: 'var(--s360-icon-blue)'}}>Checking this row removes school from PEP workflow</div>
                                    <div key={'k3'} style={{justifySelf: 'right'}}>
                                        <FormToggle readOnly={false} control={control} name={`school.pep_process_opt_out`}/>
                                    </div>
                                </div>
                            </div>
                        </BootstrapRow>}

                    </form>
                </div>

            </Fragment>

        )
    }


    const formContent = () =>
    {
        if (data.isLoading)
        {
            return (
                <div style={{textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px'}}>
                    <h4>Loading School</h4>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
            return (
                <Fragment>
                    {renderForm()}
                    <button onClick={onClickCancel} className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"></i></button>
                    <SaveButton onClick={onClickSaveForm} disabled={buttonsDisabled}>Save</SaveButton>
            </Fragment>
        )
    }

    const Title = ( props ) =>
    {
        switch ( mode )
        {
            case 'edit' :
                return <h3>Amend Provider Details</h3>
            case 'create' :
                return <h3>Create Provider</h3>
            case 'delete' :
                return <h3>Delete Provider</h3>
            default:
                return <h3>Provider</h3>
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper" columns={2}>
            <Title mode={mode} />
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-home' style={{color: 'var(--vschool-mild-blue)', fontSize: '8rem', marginTop: '30px'}} />
                </div>
                {formContent()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalSchool ;

ModalSchool.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};
